export default {
    lang: {
        chinese: '简体中文',
        english: 'English',
        tibet: '藏文',
    },
    menu: {
        dashboard: 'Home Page', //首页
        abstract: 'Introduction', //藏博概况
        'ab_history': 'Historical Development',
        'ab_structuring': 'Organization Structuring',
        'ab_words': 'Curator’s Words',
        'ab_events': 'Chronicle of Events',
        'ab_expansion_project': 'Reconstruction and Expansion Project',
        exhibition: 'Exhibition Information', //展览展讯
        'ex_zhaunti': 'Exhibitions on Special Topics',
        'ex_huimou': 'Review of Special Exhibitions',
        'ex_allsence': 'Panoramic Wandering',
        zangpinDisplay: 'Objects on Display', //臧品欣赏
        'zp_treasures': 'Treasure Appreciation',
        'zp_fast_look': 'Quick View of Cultural Relics',
        'zp_collection_donation': 'Collection and Donation of Cultural Relics',
        cultural: 'Souvenirs', //文创产品
        'cul_beautity': 'Exquisite Souvenirs',
        'cul_news': 'News about Souvenirs',
        educationActivity: 'Education Activities',
        'edu_latest_activities': 'Latest Activities',
        'edu_special_activities': 'Special Activities',
        'edu_review_activities': 'Review of Activities',
        'edu_children': 'Special Area for Children',
        'edu_Volunteers': 'Home of Volunteers',
        academic: 'Academic Research',
        'academic_institutions': 'Academic Institutions',
        'academic_book': 'Academic Periodicals',
        'academic_classroom': 'Academic Classroom',
        science_technology: 'Protection of science and technology',
        'sci_workstation': 'Introduction to Contact Workstation',
        'sci_achievements': 'Achievements of Protection and Restoration',
        'sci_knowledge': 'Science Popularization Knowledge',
    },
    search: {
        search_btn: 'Search',
        search_text: 'Please type in keywords here',
    },
    //公共
    common: {
        findMore: 'More',
        findDetails: 'Details',
        detailTitle: 'Details',
        last: 'Last',
        telPhone: 'Telephone Number',
        telPhoneTips: 'Please Input Telephone Number',
        formatError: 'Format Error',
        phoneError: 'Mobile Phone Number Format Error', //手机号码格式错误
        idCardError: 'ID Card Number Format Error', //身份证号码格式错误
        others: 'Others', //其他
        time: 'Time', //发布时间
        close: 'Close', //关闭
        refreshed: 'Refreshed', //刷新成功
        LoadMore: 'Load More', //加载更多
        noMore: 'No More',
        return: 'Back to Homepage', //返回首页
        prevPage: 'Last', //上一篇
        nextPage: 'Next', //下一篇
        NoPicture: 'No Picture for Now', //暂无图片
    },
    home: {
        MuseumNews: 'Museum News',
        Notice: 'Notice',
        OpeningClosingTime: 'Opening and Closing Time',
        TrafficRoutes: 'Traffic Routes',
        expansionProject: 'Reconstruction and Expansion Project',
        goverPublic: 'Making Party and Administrative Affairs Public',
        questionnaire: 'Questionnaire Survey',
        messageBoard: 'Message Board',
        policies: 'Policies and Regulations', //政策法规
        mailBox: 'Curator’s Letter Box',
        beautity: 'Exquisite Souvenirs',
        friendLink: 'My Links',
        addressTitle: 'Address',
        addressContent: 'No.19 on the Norbulingka Road, Chengguan District, Lhasa, Tibet Autonomous Region',
        contactNumber: 'Contact Number'
    },
    news: {
        museumNews: 'Museum News',
        notice: 'Notice',
    },
    //留言板
    msgBoard: {
        title: 'Message Board',
        textTitle: 'The public message board of Tibet museum', //西藏博物馆公众留言板
        tips: 'Please fill in the following data. We will reply as soon as possible. Thanks! Hope you can leave your consultation and precious suggestions to Tibet Museum.',
        name: 'Name',
        phoneNumber: 'Telephone Number',
        suggestion: 'Opinions and Suggestions', //意见建议
        vertifyCode: 'Please Type in the Identifying Code',
        realNamePlaceholder: 'Please fill in the real name',
        realphoneNumberPlaceholder: 'Please fill in the real mobile phone number',
        textarea: 'Please leave your questions or suggestions here',
        namePlease: 'Please type in the name', //请输入姓名
        phoneNumberPlease: 'Please type in the mobile phone number', //请输入手机号
        suggestionPlease: 'Please fill in your precious suggestions', //请填写您的宝贵意见
        vertifyCodePlease: 'Please type in the verification code', //请输入验证码
        vertifyCodeError: 'The verification code is wrong', //验证码错误
        submit: 'Submit',
        submitSuccess: 'You’ve successfully left the message',
        submitFail: 'You’ve failed to leave the message',
        FillInAgain: 'Fill in again', //重新填写
    },
    //问卷调查
    questionnaire: {
        title: 'Questionnaire Survey', //问卷调查
        finishPlease: 'Please finish the questionnaire.', //请完成答卷
        noFrequentlyPlease: 'Please do not submit so frequently.', //请不要频繁提交
        submit: 'Submit', //提交答案
        submitSuccess: 'Successfully Submitted', //提交成功
        submitFail: 'Operation Failed', //操作失败
        Resubmit: 'Resubmit', //重新提交
    },
    //馆长信箱
    mailBox: {
        title: 'Curator’s Letter Box of Tibet Museum',
        text: 'To better respond to people’s voice, now the curator’s letter box is open to the public. You are welcomed to give valuable suggestions to Tibet Museum.',
        box: 'Mailbox'
    },
    //票务预约
    appointment: {
        title: 'Ticket Reservation',
        notice: 'About Ticket Reservation',
        networkApply: 'Make a Reservation On the Internet',
        nowApply: 'Make a Reservation Now',
        today: 'Today',
        closed: 'Closed',
        chooseDatePlease: 'Please choose the reservation date', //请您先选择预约日期
        chooseDate: 'Choose the Date of Reservation',
        infoTitle: 'Personal Information',
        fillInfo: 'Fill in Personal Information',
        visitDate: 'Visiting Date', //参观时间
        tips1: 'Every adult can at most take two children below 1.3 m.', //每名成人最多可携带两名1.3m以下的儿童
        tips2: 'Please fill in real and effective identity information when you make the reservation online or make a user registration and please correctly fill in the information. If what you’ve filled in is wrong, you may not be able to get the ticket. ', //网上预约或注册用户时，请务必提供真实有效身份信息， 并正确填写， 如填写错误， 将有可能无法领取参观票。
        addPerson: 'Add Members', //添加参观者
        addPersonPlease: 'Please Add Members',
        name: 'Name',
        idType: 'ID Type',
        passport: '护照',
        idNumber: 'ID Number',
        namePlease: 'Please type in the name', //请输入姓名
        idTypePlease: 'Please select the certificate type', //请选择证件类型
        idNumberPlease: 'Please type in the certificate number', //请输入证件号码
        delete: 'Delete',
        idCard: 'ID Card',
        reset: 'Reset',
        confirmAdd: 'Confirm Add',
        confirmOrder: 'Confirm the Order',

        finishApply: 'Finish Ticket Reservation',
        success: 'Congratulations! Reservation Succeeded!',
        successNotice: 'Please visit the museum with valid documentation on that day.'
    },
    //展览展讯
    exhibition: {
        special: 'Exhibitions on Special Topics',
        review: 'Review of Special Exhibitions',
        allsence: 'Panoramic Wandering',
        detail: 'Exhibition Details',
        openDate: 'Open', //开展时间
        closeDate: 'Close', //闭展时间
        position: 'Location', //展览位置
        area: 'Area', //展览面积
        theme: 'Theme', //展览主题
        struct: 'Structure', //展览结构
        content: 'Exhibition Content', //展览内容
        relics: 'Cultural Relics on Display', //展览文物
        fullView: 'Full View of the Exhibition', //展览全景
        changSheView: '常设展览',
        linShiView: '临时展览',
        zhuanTiView: '专题展览'
    },
    //展品
    exhibits: {
        treasure: 'Treasure Appreciation',
        fastLook: 'Quick View of Cultural Relics', //文物快览
        collection: 'Collection and Donation of Cultural Relics', //文物征集与捐赠
        collectionRelics: 'Collection of Cultural Relics',
        donationRelics: 'Donation of Cultural Relics', //文物捐赠
        statues: 'Statues',//造像
        thangka: 'Thangka',//唐卡
        historicalRelics: 'Historical Relics',//历史文物
        porcelains: 'Porcelains',//瓷器
        jadeArticles: 'Jade Articles',//玉器
        religiousImplements: 'Religious Implements',//法器
        ancientBooks: 'Ancient Books',//古籍文献
        folkCustoms: 'Folk Customs',//民俗
        others: 'Others',//其他
    },
    // 文创
    cultural: {
        beautity: 'Exquisite Souvenirs', //文创精品
        product: 'Souvenirs', //文创产品
        news: 'News about Souvenirs', //文创动态
    },
    //活动
    activity: {
        latest: 'Latest Activities',
        special: 'Special Activities',
        review: 'Review of Activities',
        children: 'Special Area for Children',
        volunteers: 'volunteers',
        home: 'Home of Volunteers', //志愿者之家
        volunteersTitle: 'Tibet Museum recruits volunteers in the whole autonomous region',
        volunteersBrief: 'Applicants can apply to become volunteers throughout the year and there is no number limit. Applicants must abide by the national laws and regulations, love the country, and be passionate in museum programs for public good.',
        joinUs: 'Join us', //加入我们
        time: 'Time', //活动时间
        details: 'Activity Details', //活动详情
        download: 'Download attachments', //下载报名附件
    },
    academic: {
        institutions: 'Academic Institutions',
        book: 'Academic Periodicals',
        classroom: 'Academic Classroom',
        downloadNum: 'Downloads', //下载量
        download: 'Download', //点击下载
        noVideo: 'The video can’t be played for now. Please try again later.', //此视频暂无法播放，请稍后再试
    },
    //科技保护
    protection: {
        workstation: 'Contact Workstation',
        achievements: 'Achievements of Protection and Restoration',
        knowledge: 'Science Popularization Knowledge',
        knowledgeTitle: 'Popularization of Scientific Knowledge of Cultural Relics',
        knowledgeContent: 'Museums have their own unique advantages in adolescent education. Cultural relics of different ages and different styles are the carriers of art and aesthetics. Adolescents will feel as if entering into the hall of aesthetic art when they enter into a museum. Compared with traditional visiting and tour guide’ s introduction, adolescents are more eager to receive lively, artistic and interesting educational contents.',
        restorationTitle: 'Protection and Restoration of Objects', //臧品修复与保护
        restorationContent: 'Tibet Museum is a comprehensive museum of ethnography with a huge amount of cultural relics in diverse categories. Scientific classification is the precondition to effectively utilize the information of cultural relics and protect the cultural relics. After the cultural relics are put into the warehouse of Tibet Museum, our staff will scientifically classify them and make a registration and catalogue. According to their functions, materials, quantity, etc., the cultural relics will be classified into 19 categories including sculptures, Thangka, silk, religious instruments, ancient books, porcelains, jade articles, enamel vessels and silverware. Then they are numbered, photoed and registered.As the advantages of cultural relics, research and exhibition of Tibet Museum are more and more prominent, leaders of the museum are paying more and more attention to the scientific protection of cultural relics. Professionals have been successively sent to brother museums in China to study advanced cultural relics protection and restoration technologies and ideas and participate in the training class of protection and restoration of textile hosted by the State Bureau of Cultural Relics. In 2012, the Thangka Protection Studio was established in our museum.',
        compare: 'Comparison before and after the restoration', //修复前后对比
        before: 'Before Restoration', //修复前
        after: 'After Restoration', //修复后
    }
}